import PropTypes from 'prop-types';
import InputNumberLine from '../../../../juristec-ui/core/InputNumberLine';

const NumberInput = ({
  label, state, handle, min = 0, max = Infinity, step = 1, precision = 0, isMoney = false,
}) => {
  const handleEvent = (e) => handle(e.target.value);
  return (
    <>
      <h5 className={state.error ? 'field-error-label' : ''}>
        {label}
      </h5>
      <InputNumberLine
        value={state.value}
        onChange={handleEvent}
        setValue={handle}
        min={min}
        max={max}
        step={step}
        precision={precision}
        isMoney={isMoney}
      />
      {state.errorMsg.length > 0 && (
        <span className="field-error-msg">
          {state.errorMsg}
        </span>
      )}
    </>
  );
};

NumberInput.propTypes = {
  label: PropTypes.string.isRequired,
  state: PropTypes.shape({
    value: PropTypes.number,
    error: PropTypes.bool,
    errorMsg: PropTypes.string,
  }).isRequired,
  handle: PropTypes.func.isRequired,
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  precision: PropTypes.number,
  isMoney: PropTypes.bool,
};

export default NumberInput;
